import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeRibbon from "@/components/MarqueeRibbon";
import Manifesto from "@/components/Manifesto";
import Features from "@/components/Features";
import Gallery from "@/components/Gallery";
import ConsoleDemo from "@/components/ConsoleDemo";
import Pricing from "@/components/Pricing";
import Recensioni from "@/components/Recensioni";
import Contatti from "@/components/Contatti";
import Footer from "@/components/Footer";
import EarlyAccessModal from "@/components/EarlyAccessModal";
import PrivacyPolicy from "@/components/PrivacyPolicy";

const GRAIN =
  "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

function HomePage() {
  const [eaOpen, setEaOpen] = useState(false);
  const [eaPlan, setEaPlan] = useState("hero");

  const openEarlyAccess = (plan) => {
    setEaPlan(plan);
    setEaOpen(true);
  };

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08 });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="relative bg-void font-sans text-[#16345F] antialiased overflow-x-clip">
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[60] opacity-[0.04] mix-blend-multiply"
        style={{ backgroundImage: GRAIN }}
      />
      <Navbar onEarlyAccess={() => openEarlyAccess("nav")} />
      <main>
        <Hero onEarlyAccess={() => openEarlyAccess("hero")} />
        <MarqueeRibbon />
        <Manifesto />
        <Features />
        <Gallery />
        <ConsoleDemo />
        <Pricing onEarlyAccess={openEarlyAccess} />
        <Recensioni />
        <Contatti />
      </main>
      <Footer />
      <EarlyAccessModal open={eaOpen} plan={eaPlan} onClose={() => setEaOpen(false)} />
      <a
        data-testid="whatsapp-float-button"
        href="https://wa.me/393755398236"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Scrivici su WhatsApp"
        className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-transform duration-300 hover:scale-110"
      >
        <img src="/whatsapp-white.svg" alt="WhatsApp" className="h-8 w-8" />
      </a>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
